import React from "react";

const ServerBadge = ({children, border = 'secondary'}) => (
    <span className={`badge badge-pill border border-${border}`}>{children}</span>
);

export {
    ServerBadge
};
